import Vue from 'vue'

Vue.directive('digitsonly', (el, binding) => {
  if (!/^[0-9]+$/.test(el.value)) {
    const newValue = el.value.replace(/[^\d]/g, '')
    el.value = newValue
    binding.value = el.value
  }
})

Vue.directive('new-feature', {
  inserted (el, binding) {
    if (!binding.value.id) {
      return
    }

    const offset = binding.value.offset || [0, 0]
    const key = 'clicked-' + binding.value.id
    const clicked = !!localStorage.getItem(key)

    if (!clicked) {
      el.style.position = 'relative'

      let ind = null
      const hasInd = el.querySelector('.new-indicator')

      if (!hasInd) {
        ind = document.createElement('span')

        ind.className = 'new-indicator new-indicator--' + binding.value.id
        ind.style.position = 'absolute'
        ind.style.right = -5 + offset[0] + 'px'
        ind.style.top = -5 + offset[1] + 'px'
        ind.style.width = '4px'
        ind.style.height = '4px'
        ind.style.backgroundColor = '#dd4b39'
        ind.style.borderRadius = '50%'

        el.appendChild(ind)
      }

      if (binding.value.target === null) {
        return
      }

      const target = binding.value.target === 'parent' ? el.parentNode : el

      target.addEventListener('click', function handler () {
        localStorage.setItem(key, 1)
        document
          .querySelectorAll('.new-indicator--' + binding.value.id)
          .forEach((node) => {
            node.style.display = 'none'
          })
        target.removeEventListener('click', handler)
      })
    }
  }
})
